import React, { useState } from 'react';
import { formatAmount } from '../utils/format';
import { useTranslation } from 'react-i18next';
import noImage from '../icons/noImageIcon.svg';
import ProductPopup from '../modules/Products/ProductPopup';
import discountIcon from '../icons/discount.svg';



const ProductRow = ({ product }) => {
    const { t } = useTranslation();
    const [imageError, setImageError] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const tva = parseFloat(process.env.REACT_APP_TVA);

    const hasDiscount = product.salesDiscount && product.salesDiscount > 0;

    const handleImageError = (e) => {
        setImageError(true);
        e.target.src = noImage;
    };

    const originalTotalPrice = product.product.priceTTC * product.quantity;
    const discountedTotalPrice = product.priceTTC * product.quantity;
    const unitPriceTTC = product.unitPrice * (1 + tva);

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };


    return (
        <div className="grid grid-cols-[25%_15%_15%_15%_15%_15%] items-center bg-white p-4 rounded-[12px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
            {/* Product Info */}
            <div className="flex items-center space-x-2"
                onClick={() => handleProductClick(product.product?.id)}
            >
                <div className="flex-none w-16 h-16 bg-white rounded-md shadow-[0px_6px_26px_rgba(98,107,125,0.07)] overflow-hidden flex items-center justify-center">
                    <img
                        src={product.product?.image}
                        alt="-"
                        className={`object-contain ${imageError ? 'w-1/2 h-1/2' : 'w-full h-full'}`}
                        onError={handleImageError}
                    />
                </div>
                <div>
                    <div className="flex items-center gap-2">
                        <p className="text-[12px] font-bold text-[#043F88]">{product.product?.reference}</p>
                        {product.product?.discount > 0 && product.discount !== null && (
                            <p className="inline-flex items-center gap-1 text-[12px] bg-[#FFD700] rounded-[12px] px-1 py-0.5 font-bold text-[#043F88]">
                                <img src={discountIcon} alt="discount" className="w-3 h-3" />
                                <span>{product.product?.discount}%</span>
                            </p>
                        )}
                    </div>
                    <p className="text-[#6B78F8] font-semibold">
                        {product.product.name}
                    </p>
                </div>
            </div>

            {/* Quantity */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.quantity').toUpperCase()}
                </p>
                <p className="text-[#043F88] text-[20px] font-medium">
                    {product.quantity}
                </p>
            </div>

            {/* Discount */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.discount').toUpperCase()}
                </p>
                <p className="text-[#043F88] text-[20px] font-medium">
                    {product.salesDiscount || 0}%
                </p>
            </div>

            {/* Price HT */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceHT')}
                </p>
                {hasDiscount ? (
                    <>
                        <p className="text-[#043F88] text-[20px] font-semibold">
                            {formatAmount(product.priceHT)}
                        </p>
                        <p className="text-[#A0A0A0] text-[14px] line-through">
                            {formatAmount(product.product.priceHT)}
                        </p>
                    </>
                ) : (
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(product.unitPrice || product.product.priceHT)}
                    </p>
                )}
            </div>

            {/* Price TTC */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceTTC')}
                </p>
                {hasDiscount ? (
                    <>
                        <p className="text-[#043F88] text-[20px] font-semibold">
                            {formatAmount(product.priceTTC)}
                        </p>
                        <p className="text-[#A0A0A0] text-[14px] line-through">
                            {formatAmount(product.product.priceTTC)}
                        </p>
                    </>
                ) : (
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(unitPriceTTC || product.product.priceTTC)}
                    </p>
                )}
            </div>

            {/* Total Price */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.totalPrice')}
                </p>
                {hasDiscount ? (
                    <>
                        <p className="text-[#043F88] text-[20px] font-semibold">
                            {formatAmount(discountedTotalPrice)}
                        </p>
                        <p className="text-[#A0A0A0] text-[14px] line-through">
                            {formatAmount(originalTotalPrice)}
                        </p>
                    </>
                ) : (
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(unitPriceTTC * product.quantity || originalTotalPrice)}
                    </p>
                )}
            </div>

            {selectedProduct && (
                <ProductPopup
                    productId={selectedProduct}
                    onClose={() => setSelectedProduct(null)}
                />
            )}
        </div>
    );
};

export default ProductRow;
